import { MLFLOW_INTERNAL_PREFIX } from '../../common/utils/TagUtils';

export const NOTE_CONTENT_TAG = MLFLOW_INTERNAL_PREFIX + 'note.content';
